<template>
  <div class="footer">
    <div class="footer-center">
      <div class="footer-left">
        <div class="footer-icon">
          <span class="footer-img"></span>
          <!-- <span class="footer-words">{{$t('footer.pro_anchor_exclusive')}}</span> -->
        </div>
        <div class="footer-icon">
          <i class="iconfont icon-global">&#xe6cd;</i>
          <span class="footer-words">{{ $t("footer.global_events") }}</span>
        </div>
        <div class="footer-icon">
          <i class="iconfont icon-global">&#xe603;</i>
          <span class="footer-words">{{ $t("footer.hd_live") }}</span>
        </div>
        <div class="footer-icon">
          <i class="iconfont icon-global">&#xe62d;</i>
          <span class="footer-words">{{ $t("footer.pro_anchor") }}</span>
        </div>
        <div class="footer-icon">
          <i class="iconfont icon-global">&#xe606;</i>
          <span class="footer-words">{{ $t("footer.massive_data") }}</span>
        </div>
        <div
          class="footer-icon"
          v-for="(item, index) in moreList"
          :key="`footer_${index}`"
          @click="toDetail(item.url, item.name)"
        >
          <i class="iconfont new-icon" :class="item.className"></i>
          <span class="footer-words">{{ $t(`footer.${item.key}`) }}</span>
        </div>
      </div>
      <div class="footer-right">
        <div class="app-download">
          <a
            :href="$store.state.downloadImg.ipa_url"
            class="app-top"
            @click="clickTime(2)"
            >{{ $t("footer.ios_download") }}</a
          >
          <a
            :href="$store.state.downloadImg.apk_url"
            class="app-bottom"
            @click="clickTime(1)"
            >{{ $t("footer.android_download") }}</a
          >
        </div>
        <div class="app-img">
          <img
            v-lazy="$store.state.downloadImg.qr_url"
            :alt="$t('footer.qr_code')"
          />
        </div>
      </div>
    </div>
    <!-- 版权等信息建议也用多语言，视实际需求而定 -->
  </div>
</template>

<script>
import { clickStatistics, apiGetFootMsg } from "./../http";
export default {
  name: "pagefooter",
  data() {
    return {
      moreList: [
        { name: "用户协议", key: "user_agreement", className: "icon-procol" },
        { name: "隐私政策", key: "privacy_policy", className: "icon-privacy" },
        { name: "免责声明", key: "disclaimer", className: "icon-disclaimer" },
        {
          name: "权限详情",
          key: "permission_details",
          className: "icon-authority",
        },
      ],
    };
  },
  mounted() {
    this.getMsg(); // 获取底部信息
  },
  methods: {
    to(index, title) {
      let url = this.moreList[index].url;
      if (url) {
        this.$router.push({
          path: "information",
          query: {
            url: url,
            title: title,
          },
        });
      }
    },
    toDetail(url, title) {
      if (url) {
        this.$router.push({
          path: "information",
          query: {
            url: url,
            title: title,
          },
        });
      }
    },
    getMsg() {
      apiGetFootMsg()
        .then((res) => {
          if (res.code === 0 && res.info.length > 0) {
            for (let item of res.info) {
              for (let items of this.moreList) {
                if (item.name === items.name) items.url = item.href;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clickTime(prop) {
      clickStatistics({ type: 1, action: prop });
    },
  },
};
</script>

<style scoped>
.footer {
  min-width: 120rem;
  /* height: 13.5rem; */
  background: #32302c;
}

.footer-center {
  width: 120rem;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
}

.footer-left {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.footer-icon {
  padding: 0 2.3rem;
  display: flex;
  flex-direction: column;
  color: #959492;
  font-size: 1.2rem;
  align-items: center;
}
.new-icon {
  display: inline-block;
  width: 38px;
  height: 38px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACE8iBbAAADgklEQVRYCe1WTWgTQRR+bxNtY63F4k3xB0FRj9KLepKCUuhBhIoe0tK0zZ8oIiiCR8GD9FTzs0la2njRghehEFC8CMWDFw8qPSiIeFKqtdqmNrvPN2knieluspNt0UMDm5l58733ffvezOwAbP7UMoB28LSeuENE1/lptsO4tSNinp/hwWD4dnUsrdogx6Zp3txIUYJHxBc8krOytRXGIG8lcAP7ljy1hG2glvqhGxSGn+qHdodQFqZpeCMYjuzV0HOpRK3huWbQ9tR6ELQLJbyDjmV9a/kRgbEyb5gS5yEyzGbfql1aq9rlvCE9q2Yshw0Io+FUMnaZAPfzvioGNQieGPmFYn+9/pSFCWLO2gEpar2EVMdRFoaAzwDxTXWgumOiYwTUWRe3ClAW5kHtViAUeuWUQOLS6fhxKoBjP2VhBplxPRmfkYROWzLgkFOswCkL43J08JrvUCER2JVt4txL+RxzHtodUjlj4oAFDV6o0pJBp3g333PqpyzMBHodHIy+dEogcelksrV0NktjjVZZGBLm9ESs9ilvQUhgeizMtiZlYXyHEpfLRvxsRVhN2C9+hBzfLpUzY0ViZyvGZx6redurtQBPJBK7l5D8vGh7ecMftgrQmA1nEGGiiTDbGw5/topREqYnY9M82MGgePO21gm/3/+r0iGVip0AE/pYpLi+CJzq7weLecQ7enxoKDotnScnJ7d/n/3i53EECOeGwpGTYq4sLBErn4GIc4g0RuCNBYPB9zKIaDmQb27263nenX383Ty9uuYqIaU+l4rfg55rgONt7bse9/T0LMpJXdcPIhSivGT7+VbQJu3BcLSoyVqYRAHnCHFKA21kMBR6Wjav9DKZzD7DWL7I9GdYwVF+zZ18xH/jzLxlRE7zbn04MDDwUfqJl8joeieReYUFd7F9zRp3KkzGZE58RxqO+Hwt2eoyl0A2nWw225JfmO/lUvE9jo7YwIpmKczxti8GNCm+uPDzbkqPjXm34P3+/siHWiSyXOzD5QIuV3m11PITc46FlQLxeuCyXVteoqt8y5jiVD7weptygUBgXmBGR0dbC4Wls2iCn8xCF0vhcjkXJHnUhUlPQUjUzZzdhd95SCXjs2KK++2iVZcivMo/N8LKUbjHC7so6C+ji8GaXeEi1rq6bgpTTedmxhrOGH9G1nxyVIO5xf8PGty+w7/z/wOj1TaZT9IzEgAAAABJRU5ErkJggg==);
  cursor: pointer;
}

.icon-procol {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACE8iBbAAADgklEQVRYCe1WTWgTQRR+bxNtY63F4k3xB0FRj9KLepKCUuhBhIoe0tK0zZ8oIiiCR8GD9FTzs0la2njRghehEFC8CMWDFw8qPSiIeFKqtdqmNrvPN2knieluspNt0UMDm5l58733ffvezOwAbP7UMoB28LSeuENE1/lptsO4tSNinp/hwWD4dnUsrdogx6Zp3txIUYJHxBc8krOytRXGIG8lcAP7ljy1hG2glvqhGxSGn+qHdodQFqZpeCMYjuzV0HOpRK3huWbQ9tR6ELQLJbyDjmV9a/kRgbEyb5gS5yEyzGbfql1aq9rlvCE9q2Yshw0Io+FUMnaZAPfzvioGNQieGPmFYn+9/pSFCWLO2gEpar2EVMdRFoaAzwDxTXWgumOiYwTUWRe3ClAW5kHtViAUeuWUQOLS6fhxKoBjP2VhBplxPRmfkYROWzLgkFOswCkL43J08JrvUCER2JVt4txL+RxzHtodUjlj4oAFDV6o0pJBp3g333PqpyzMBHodHIy+dEogcelksrV0NktjjVZZGBLm9ESs9ilvQUhgeizMtiZlYXyHEpfLRvxsRVhN2C9+hBzfLpUzY0ViZyvGZx6redurtQBPJBK7l5D8vGh7ecMftgrQmA1nEGGiiTDbGw5/topREqYnY9M82MGgePO21gm/3/+r0iGVip0AE/pYpLi+CJzq7weLecQ7enxoKDotnScnJ7d/n/3i53EECOeGwpGTYq4sLBErn4GIc4g0RuCNBYPB9zKIaDmQb27263nenX383Ty9uuYqIaU+l4rfg55rgONt7bse9/T0LMpJXdcPIhSivGT7+VbQJu3BcLSoyVqYRAHnCHFKA21kMBR6Wjav9DKZzD7DWL7I9GdYwVF+zZ18xH/jzLxlRE7zbn04MDDwUfqJl8joeieReYUFd7F9zRp3KkzGZE58RxqO+Hwt2eoyl0A2nWw225JfmO/lUvE9jo7YwIpmKczxti8GNCm+uPDzbkqPjXm34P3+/siHWiSyXOzD5QIuV3m11PITc46FlQLxeuCyXVteoqt8y5jiVD7weptygUBgXmBGR0dbC4Wls2iCn8xCF0vhcjkXJHnUhUlPQUjUzZzdhd95SCXjs2KK++2iVZcivMo/N8LKUbjHC7so6C+ji8GaXeEi1rq6bgpTTedmxhrOGH9G1nxyVIO5xf8PGty+w7/z/wOj1TaZT9IzEgAAAABJRU5ErkJggg==);
}
.icon-privacy {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACE8iBbAAADxElEQVRYCe1Y3UsUURS/Z2aTCrQMpA+ijxelD8qCggqChR7Kl7DIohKSal01fOkPiN6C6C33YyQ1RAyFyJciKKwejLKIHvzKl6iHiIotzVh0Zm6/u6nMjnd2rrurRHRhl3vPOfec35zP2WXs/5qfB0gmbkQjnZzxUzJevmlErDMUbjjt1qu5CakzsZNS+oIQSeoAKTDOudSTC4HLy1YgF2NEZOF+G9PoqW7TkKVZhGfaymwWZIxXgyd9cBWbOQCjjzrTjp0Ph1+5DPXjfPtWLBY3uXUX+zUuvtIxW2C2TtpZAaqrq2tZIvGtnnFeTqgYRvz1+g2bYxUVFc8NI3qO2fyBV7gyIcwOGNGjC+Hws97e3sC7kcHHgLNPGOF/vqo/fnh/FGAOIdQPjVikD+QDgjWflVUOoDJeCiOjo4N7Z0ClGeU82NzcvGOa9iKNp3jIwmOUQEqLPEL0AhaR2SWzpaEQUnROAlgC0sUyOS+atC3Eo02pqLgvkcZuriwuuVxVVTXp5mU6Iw8Lvie+3OA2uySTq61rmIND2WPEqO9iqK4RecNbWlpKLCu5VmbETdP1pZ/wIF+Qc43Nsehu1Md+t4zsrAwMCnsEKLSBnVOTyX7EcYlMoZtmW8kp3NmDu28RiR7wlYApJz/p2ldh1OJ8uxQUUTcjuucGJmRTd8CY0TFHRkJQBia5O0vCIP4cqq07WVq25QTMI9FzX3kBhpYxLsIcDAZNQPqZO6wcZpnTONr97AMSQ+3lYSknfyZbCGVJPB5fnpLh1irkVSZxJV5egKEVFBIz38BzeLvghUqWfYTUgdl8ndClF/BX5iQbw7bIqRtOKp2elk6y2I8xXU9NCgz0lA63gOysDozx4xja15DgI62tratN01whU+imBQKBHzU1NUkx8EdHBo+7+V5nZWDwSPno8FB7R0ek/syZGtESkl5K3XTcKX43MhRF9Za7eV5nZWBCgfiBMjFOx+LRyACGmwin70IZFE2Ms20oiAJfYYfAvICJe0huYWDXfOoumyKd7T8OsH/F1tdj6FEDQNqGzi66utKCh8rg2bCSsIeQLzBOdLW2tr7b474nOR6LHEbcN3kK+DB8gaFjXjFiTRuz8FjWoARmX2AIyzbIXUdohPyiLV9gmDK/MJifANFU3lBx0tF6DkJf2vRw6vcFRhqFQ6H6duelfOwNI3KEW/y+ly5fYMy2Kw2jaZixJXnzGApct83Mf9z4AkNqVTILn3xG0stNDrq0wYq3UYfMgm69bEmBYfDcWVA0acoX01aa4X/s8Budpk++VVTRDwAAAABJRU5ErkJggg==);
}
.icon-disclaimer {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACE8iBbAAACiklEQVRYCe1YT4vTQBSfSWKpLop68OjdD+DRLyDsQUFExEM3Jq1FZBFZ9CDFm6DoeuhusmssFFHpwYOfwYMIfgHPnlSWyrp/rM483+vaJunOZDPZIntILnl/fu+9X38zk5IwVl5mCnAzeIzu9XqV/tr3mwCsxjk7AwA2ZTnnA4x9Riv0G402+hBX5bcKEUNSdn/t2zskcD5rFJKK/EbzehZGlzMihqrwKIpOgxhckBKeUlMc/thy+CvGDq2TL4Q4xkFcRext8i1uX2K2/cHzvC/k571yEwvD5VscoIUDT46bc/6y3mheG/sJIwyW3jCAy3GIf+U2v+f7N17EMb1l6VNxZjVou0zKZylSmLZsthij0hbmHqUjcAqEjFaD4Eo6rvYcdTgdlcDnGaM9zJ8jmzv1ev1HGrHb87zmJyqgTLfbndna/PkEFfSBiQUMvaZ41qVcStxHR8VgexHbXsQNfnzcwHLOIan3Y9/AWFlpnwXBPo5K8CT38be+tSvVedd1h/tzlKO7UjEihfrMDUVKokEsREGwDo6zkQzvZUv56wRIfn9H9R30vx88h7Mo4E72UBIjpXaRokqA2T9MzLLfYrJPDl/zOKNZCmLKzZ9avhwj9wPRzVIS28+gadWWxEyVLBUzVUz9uMju8qBSPfKwVqsNH0DZUMY6nU51sL15F3GtvbDJvPFSHp6xlvKSokGEpZrk0Dy2MbGtDdkkFfI0JwxhqSYvfoQrspQtXJpWuNwe9ci8IzYzr0saK6ZrNO34gSVWZCnLU2m0PcpTaSTXfwQf2FNZEjPdBaViU1Fs+DJq2qkgXjdLvZT4hlxwjnmZZpbyv5Je24dvyJOfCMzHaiuSnwi0oDJhoMBfyFH35BnsFzYAAAAASUVORK5CYII=);
}
.icon-authority {
  background: url(data:image/png;base64,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);
}
.footer-words {
  margin-top: 1.2rem;
}
.footer-img {
  width: 13rem;
  height: 4rem;
  display: inline-block;
  background: var(--img-foologo) no-repeat;
  background-size: 100% 100%;
}

.icon-global {
  font-size: 3.8rem;
  color: #999795;
}

.footer-right {
  display: flex;
  align-items: center;
}

.app-download {
  display: flex;
  flex-direction: column;
  margin-right: 2.8rem;
}

.app-download a {
  width: 14rem;
  height: 4rem;
  border-radius: 0.3rem;
  background: var(--primary-color);
  color: #fff;
  font-size: 1.6rem;
  line-height: 4rem;
  text-align: center;
  cursor: pointer;
}

.app-bottom {
  margin-top: 1.6rem;
}

.app-img {
  width: 9rem;
  height: 9rem;
}

.app-img img {
  width: 100%;
  height: 100%;
}
.copyright {
  width: 120rem;
  text-align: center;
  background: #32302c;
  color: #959492;
  margin: auto;
  padding: 3rem 0;
  line-height: 1.5;
}
.copyright a {
  color: #959492;
}
</style>



// WEBPACK FOOTER //
// src/base/footer.vue